import React, {useContext} from 'react';
import {TableWrapper} from '@/components/table/TableWrapper'
import {getAuthLog} from '../../../logs/core/_requests'
import {getColumns} from '../../../logs/auth/columns/_columns'
import {useIntl} from 'react-intl'
import {CustomerContext} from '../CustomerContext'

const Auth = () => {
  const intl = useIntl()
  const { customer } = useContext(CustomerContext)

  if (!customer) {
    return (<></>)
  }

  return (
    <TableWrapper
      dataProvider={(query: string) => {
        query+= `&userId=${customer._id}`
        return getAuthLog(query)
      }}
      cols={getColumns(intl).slice(1, -1)}
      queryId={`P2C_CUSTOMER_${customer._id}_AUTH_LIST`}
      lookup={{placeholder: `${intl.formatMessage({id: 'CORE.USERS.ACTIVITY.LOOKUP_PLACEHOLDER'})}`}}
    />
  )
}

export default Auth;
